import { AxiosResponse } from "axios";
import { ERRORS } from "./types";

export const shouldRefreshToken = (response: AxiosResponse<any>): boolean =>
  response.status === 401 &&
  response.data.payload.message === ERRORS.EXPIRED_TOKEN &&
  response.data.header.messageType !== "refreshWebSessionV1";
